export default __webpack_public_path__ + "static/media/Icons_Electric Icon.2e18c272.svg";